module.exports = __webpack_public_path__ + "img/culture_02.9fcb2f40.png";